import React from 'react';
import { ActionIcon, ActionIconProps } from '@mantine/core';
import { Icon3dCubeSphere } from '@tabler/icons-react';
import type { IProduct } from '@/types/Product.model';
import { useAnnotationLinkedProduct } from '@/hooks/useAnnotationLinkedProduct';

interface AnnotationProductOpenButtonProps {
  productId: string;
  onOpen: (product: IProduct) => void;
  style?: React.CSSProperties;
  className?: string;
  size?: ActionIconProps['size'];
}

/** 3D icon: loads linked product with password / restricted link-share handling. */
export function AnnotationProductOpenButton({
  productId,
  onOpen,
  style,
  className,
  size = 'sm',
}: AnnotationProductOpenButtonProps) {
  const { openByProductId, accessModal } = useAnnotationLinkedProduct(onOpen);

  return (
    <>
      <ActionIcon
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          void openByProductId(productId);
        }}
        style={style}
        className={className}
        size={size}
      >
        <Icon3dCubeSphere size={16} />
      </ActionIcon>
      {accessModal}
    </>
  );
}
